module.exports = __webpack_public_path__ + "img/pic1@2x.35211854.png";